var _templateObject = _taggedTemplateLiteralLoose(['\n\tbox-sizing: border-box;\n\tdisplay: ', ';\n\t', '\n\t', '\n'], ['\n\tbox-sizing: border-box;\n\tdisplay: ', ';\n\t', '\n\t', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import styled from 'styled-components';
import { mapTheme, mapBreakpoints } from '../utils/breakpoints';

var getCellDisplay = function getCellDisplay(p) {
  return p.flex ? 'flex' : 'block';
};

var Cell = styled.div(_templateObject, getCellDisplay, mapTheme(function (_ref) {
  var gutter = _ref.gutter;
  return gutter && '\n\t\tpadding-left: ' + gutter / 2 + 'px;\n\t\tpadding-right: ' + gutter / 2 + 'px;\n\t';
}), mapBreakpoints(function (value, props) {
  return '\n\t\tdisplay: ' + (value > 0 ? getCellDisplay(props) : 'none') + ';\n\t\twidth: ' + ((value / props.theme.griding.columns || 1) * 100 + '%') + ';\n\t';
}));
export default Cell;